// Reads the translation overlay from a questions response as
// `{ availableLanguages, translations }`, or null when it has none. Preview and the
// encrypted serve send a plain `translation_overlay`. The CFOD take serve sends an
// obfuscated `z`, which `decode` turns back into the overlay.

const normalize = (overlay) => ({
  availableLanguages: overlay.available_languages ?? [],
  translations: overlay.translations ?? {},
});

export const translationOverlayFromResponse = (data, decode) => {
  const plain = data?.translation_overlay;
  if (plain) return normalize(plain);

  if (data?.z != null) {
    try {
      return normalize(decode(data.z));
    } catch {
      return null;
    }
  }

  return null;
};
